<upload 
    action="/api/upload"
    [fileList]="fileList"
    listType="picture"
    accept="image/png, image/jpeg"
>
</upload>